<template>
    <Badge :text="text" :type="type" class-name="badge-msg"></Badge>
</template>
<script>
export default {
    props:{
        text:{
            type:String,
            default:''
        },
        type:{
            type:String,
            default:'primary'
        }
    }
}
</script>
<style lang="less">
@font: Roboto Mono,monospace;
.badge-msg{
    box-shadow: none !important;
    border-radius: 4px !important;
    height: 18px !important;
    border: none !important;
    min-height: 18px;
    font-family: @font !important;
    font-size: 12px !important;
    &:hover{
        cursor: pointer;
    }
}
</style>
